module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-100-Classes-Inactive-b46734ed110ccd215ecf157edb0eed87.png";